<template>
    <div>
        <div class="row">
            <div class="col-4">
                <form-row label="Rahmenart">
                    <form-select v-model="borderStyle" :options="borderOptions"/>
                </form-row>
            </div>
            <div class="col-4">
                <form-row label="Farbe">
                    <div class="flex">
                        <form-input :model-value="borderColor ? '#' + borderColor : 'Transparent'" readonly/>
                        <color-picker v-model="borderColor"/>
                    </div>
                </form-row>
            </div>
            <div class="col-4">
                <form-row label="Breite">
                    <form-input v-model="borderWidth" placeholder="Breite"></form-input>
                </form-row>
            </div>
            <div class="col-12">
                <div class="infobox infobox-border">
                    Bitte beachten Sie auch die Einstellungen innerhalb der Tabelleneigenschaften.
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-4">
                <form-row label="Hintergrundfarbe">
                    <div class="flex">
                        <form-input :model-value="backgroundColor ? '#' + backgroundColor : 'Transparent'" readonly/>
                        <color-picker v-model="backgroundColor"/>
                    </div>
                </form-row>
            </div>
            <div class="col-4">
                <form-row label="Textfarbe">
                    <div class="flex">
                        <form-input :model-value="color ? '#' + color : 'Transparent'" readonly/>
                        <color-picker v-model="color"/>
                    </div>
                </form-row>
            </div>
        </div>
        <hr class="no-margin-top">
        <div class="row">
            <div class="col-8">
                <div class="row">
                    <div class="col-6">
                        <form-row label="Breite">
                            <form-input v-model="width" placeholder="Breite"></form-input>
                        </form-row>
                    </div>
                    <div class="col-6">
                        <form-row label="Höhe">
                            <form-input v-model="height" placeholder="Höhe"></form-input>
                        </form-row>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <form-row label="Innenabstand">
                    <form-input v-model="padding" placeholder="Innenabstand"></form-input>
                </form-row>
            </div>
        </div>
        <hr class="no-margin-top">

        <div class="row">
            <div class="col-7">
                <form-row label="Ausrichtung des Zellentextes">
                    <form-select v-model="textAlign" :options="textAlignOptions"/>
                </form-row>
            </div>
            <div class="col-5">
                <form-row label="Rahmenart">
                    <form-select v-model="verticalAlign" :options="verticalAlignOptions"/>
                </form-row>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import ColorPicker from '@/components/ColorPicker.vue';
    import FormInput from '@/components/form/FormInput.vue';
    import FormInputCheckbox from '@/components/form/FormInputCheckbox.vue';
    import FormRow from '@/components/form/FormRow.vue';
    import FormRowStatic from '@/components/form/FormRowStatic.vue';
    import FormSelect from '@/components/form/FormSelect.vue';
    import {SubmitIcons} from '@/library/design';
    import {popupDefaultCancelButton} from '@/library/popup';
    import {toKebabCase} from '@/library/utils';
    import FroalaEditor from 'froala-editor';
    import tinycolor from 'tinycolor2';
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import AppPopup from '../components/AppPopup.vue';
    import PortunaBox from './PortunaBox.vue';

    @Component({
        name: 'FroalaCellPopup',
        components: {
            FormInputCheckbox,
            ColorPicker,
            FormRow,
            FormRowStatic,
            AppPopup,
            PortunaBox,
            FormInput,
            FormSelect,
        },
    })
    export default class FroalaCellPopup extends Vue
    {
        @Prop({
            type: Object,
            required: true,
        }) editor: FroalaEditor;

        @Prop({
            type: Array,
            required: true,
        }) cells: HTMLTableCellElement[];

        borderStyle: string | 0 = 0;

        borderColor = '';

        borderWidth = '';

        backgroundColor = '';

        width = '';

        height = '';

        padding = '';

        textAlign: string | 0 = 0;

        verticalAlign: string | 0 = 0;

        color = '';

        created()
        {
            const buttons: PopupButton[] = [
                popupDefaultCancelButton,
                {
                    'title': 'Speichern',
                    'icon': SubmitIcons.save,
                    'type': 'success',
                    'cmd': this.updateElement,
                },
            ];

            this.emitter.emit('setButtons', buttons);

            this.borderStyle     = this.cells[0].style.borderStyle ? this.cells[0].style.borderStyle : 0;
            this.borderColor     = this.cells[0].style.borderColor ? tinycolor(this.cells[0].style.borderColor).toHex().replace('#', '') : this.cells[0].style.borderColor;
            this.borderWidth     = this.cells[0].style.borderWidth;
            this.backgroundColor = this.cells[0].style.backgroundColor
                ? tinycolor(this.cells[0].style.backgroundColor).toHex().replace('#', '')
                : this.cells[0].style.backgroundColor;
            this.width           = this.cells[0].style.width;
            this.height          = this.cells[0].style.height;
            this.padding         = this.cells[0].style.padding;
            this.textAlign       = this.cells[0].style.textAlign ? this.cells[0].style.textAlign : 0;
            this.verticalAlign   = this.cells[0].style.verticalAlign ? this.cells[0].style.verticalAlign : 0;
            this.color           = this.cells[0].style.color ? tinycolor(this.cells[0].style.color).toHex().replace('#', '') : this.cells[0].style.color;
        }

        borderOptions: SelectOption[] = [
            {
                label: 'Kein Rahmen',
                value: 0,
            },
            {
                label: 'Durchgezogen',
                value: 'solid',
            },
            {
                label: 'Gepunktet',
                value: 'dotted',
            },
            {
                label: 'Gestrichelt',
                value: 'dashed',
            },
            {
                label: 'Doppelt',
                value: 'double',
            },
            {
                label: 'Eingeritzt',
                value: 'groove',
            },
            {
                label: 'Hevorgehoben',
                value: 'ridge',
            },
            {
                label: 'Eingelassen',
                value: 'inset',
            },
            {
                label: 'Geprägt',
                value: 'outset',
            },
        ];

        textAlignOptions: SelectOption[] = [
            {
                label: 'Zellentext linksbündig ausrichten',
                value: 0,
            },
            {
                label: 'Zellentext zentriert ausrichten',
                value: 'center',
            },
            {
                label: 'Zellentext rechtsbündig ausrichten',
                value: 'right',
            },
            {
                label: 'Zellentext als Blocksatz ausrichten',
                value: 'justify',
            },
        ];

        verticalAlignOptions: SelectOption[] = [
            {
                label: 'Zellentext oben ausrichten',
                value: 0,
            },
            {
                label: 'Zellentext mittig ausrichten',
                value: 'middle',
            },
            {
                label: 'Zellentext unten ausrichten',
                value: 'bottom',
            },
        ];

        updateElement()
        {
            let hasSelection = true;

            const selection = this.editor.selection.get() as Selection;
            const focusNode = selection.focusNode as Nullable<HTMLElement>;
            if (focusNode && focusNode.classList && focusNode.classList.contains('fr-element'))
            {
                hasSelection = false;
            }

            hasSelection && this.editor.selection.save();

            if (!this.editor.undo.canDo())
            {
                this.editor.undo.saveStep();
            }

            for (const cell of this.cells)
            {
                for (const style of ['borderStyle', 'borderColor', 'borderWidth', 'backgroundColor', 'width', 'height', 'padding', 'textAlign', 'verticalAlign', 'color'])
                {
                    if (this[style])
                    {
                        const isColor = ['borderColor', 'backgroundColor', 'color'].includes(style);
                        cell.style.setProperty(toKebabCase(style), isColor ? '#' + this[style] : this[style]);
                    }
                    else
                    {
                        cell.style.removeProperty(toKebabCase(style));
                    }
                }
            }

            hasSelection && this.editor.selection.restore();

            this.editor.undo.saveStep();

            this.emitter.emit('close');
        }
    };
</script>